import { useCart } from "../CartContext";
import { NavLink } from "react-router-dom";
import Checkout from "../components/Checkout";
import { useState } from "react";

const CartPage = () => {
  const [checking, setChecking] = useState(false);
  const { cart, addToCart, decreaseQuantity, removeFromCart, setCart } =
    useCart();
  const cartItem = cart.reduce((sum, element) => sum + element.price, 0);
  console.log(cartItem);

  checking
    ? (document.body.style.overflowY = "hidden")
    : (document.body.style.overflowY = "auto");
  return (
    <div className="relative py-[50px] px-[10px]">
      <h2 className="text-left font-[600] text-[30px]">Cart</h2>
      <div className="flex flex-col lg:flex-row gap-5">
        <div className="w-[100%] lg:w-[75%] flex items-center justify-start">
          {cart.length === 0 ? (
            <div className="w-[100%]">
              <div className="flex items-center gap-3 my-[10px] bg-gray-200 py-[15px] px-[20px] text-gray-500">
                <i class="fa-regular fa-bell"></i>
                <p>Your cart is currently empty.</p>
              </div>
              <NavLink to={"/shop"}>
                <button className="font-[600] bg-black text-white my-[10px] py-[10px] px-[10px] rounded-[5px] hover:bg-amber-500 hover:text-black">
                  Return to shop
                </button>
              </NavLink>
            </div>
          ) : (
            <table className="text-center">
              <thead>
                <tr className="bg-amber-500 font-[600] rounded-[40px]">
                  <th className="w-[300px] py-[10px] text-white rounded-tl-[5px] rounded-bl-[5px]">
                    Product
                  </th>
                  <th className="w-[200px] py-[10px] text-white">Quantity</th>
                  <th className="w-[200px] py-[10px] text-white">Subtotal</th>
                  <th className="w-[200px] py-[10px] text-white rounded-tr-[5px] rounded-br-[5px]">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item) => (
                  <tr className="h-[250px] lg:h-[150px]">
                    <td>
                      <div className="flex flex-col lg:flex-row items-center justify-center gap-3">
                        <img src={item.image} alt="" className="h-[100px]" />
                        <div className="flex flex-col items-start text-left">
                          <h3>{item.name}</h3>
                          <p>${item.overallprice.toFixed(2)}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="flex flex-col lg:flex-row items-center justify-center gap-3">
                        <button
                          className="py-[5px] px-[10px] rounded-[5px] bg-amber-500 font-[600] text-white hover:bg-amber-600"
                          onClick={() => decreaseQuantity(item.id)}
                        >
                          -
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          className="py-[5px] px-[10px] rounded-[5px] bg-amber-500 font-[600] text-white hover:bg-amber-600"
                          onClick={() => addToCart(item)}
                        >
                          +
                        </button>
                      </div>
                    </td>
                    <td>${item.price.toFixed(2)}</td>
                    <td>
                      <button
                        className="hover:text-amber-500"
                        onClick={() => removeFromCart(item.id)}
                      >
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div
          className={`border-[2px] border-gray-200 rounded-[5px] w-[100%] lg:w-[25%] py-[50px] px-[30px] h-[50vh] ${
            cart.length === 0 ? "hidden" : "block"
          }`}
        >
          <h2 className="font-[600] text-[20px] mb-[10px]">Cart totals</h2>
          <div className="flex items-center justify-between my-[30px]">
            <h3 className="text-gray-600 font-[600] text-[17px]">Subtotal</h3>
            <p className="text-gray-600 text-[17px] font-[100]">
              ${cartItem.toFixed(2)}
            </p>
          </div>
          <hr />
          <div className="flex items-center justify-between my-[30px]">
            <h3 className="text-gray-600 font-[600] text-[17px]">Total</h3>
            <p className="text-gray-600 font-[600] text-[17px]">
              ${cartItem.toFixed(2)}
            </p>
          </div>
          <button
            onClick={() => setChecking(true)}
            className="bg-black text-white font-[600] relative left-[50%] translate-x-[-50%] my-[10px] py-[10px] px-[30px] rounded-[5px] hover:bg-amber-500 hover:text-black transition-all duration-500 ease-in-out"
          >
            Proceed to Checkout
          </button>
        </div>
      </div>
      {checking === true ? (
        <div>
          <div
            className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-[100%] w-[100%] bg-[#00000067] flex items-center justify-center"
            onClick={() => setChecking(false)}
          ></div>
          <div className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] flex items-center justify-center">
            <Checkout setCart={setCart} setChecking={setChecking} />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CartPage;
